import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function CEOMessageSection() {
  const { ref: headRef, isVisible: headVisible } = useScrollReveal<HTMLDivElement>();
  const { ref: msgRef, isVisible: msgVisible } = useScrollReveal<HTMLDivElement>();

  return (
    <section id="message" className="relative py-24 md:py-36 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/4616f3580ac5784bdcd00c85ed0533a4.jpg"
          alt="夜明けの山"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-charcoal/70" />
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-6 md:px-10">
        {/* Section label */}
        <div className="flex items-center gap-4 mb-16">
          <span className="font-sans text-terracotta text-[11px] tracking-[0.4em] uppercase">01</span>
          <div className="flex-1 h-px bg-white/20" />
          <span className="font-sans text-white/50 text-[11px] tracking-[0.3em]">Message</span>
        </div>

        <div className="max-w-3xl">
          <div
            ref={headRef}
            className={`mb-12 transition-all duration-900 ${headVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
          >
            <h2 className="font-serif text-white text-2xl md:text-3xl lg:text-4xl leading-loose">
              代表より
            </h2>
          </div>

          <div
            ref={msgRef}
            className={`space-y-7 font-sans text-white/80 text-sm md:text-base leading-loose transition-all duration-1000 delay-200 ${msgVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
          >
            <p>
              Chammiは、日本のコンテンツ——アニメ、漫画、ゲーム——を、もっと広く、もっと遠くへ届けたいという想いから生まれた会社です。
              東京とロサンゼルスを拠点に、IPのグローバル展開支援をしてきました。
            </p>
            <p>
              そして今、私たちは新しい一歩を踏み出そうとしています。
              AIを活用したアニメ制作スタジオを、高知の地に作ること。
              それは単なる「事業拡張」ではなく、日本のクリエイティブ産業の未来をもう一度問い直す試みです。
            </p>
            <p>
              このスタジオを率いてくれる人を探しています。
              アニメの知識がなくても構いません。大切なのは、人を動かし、チームを育て、
              曖昧な状況の中でも前に進み続けられる力です。
            </p>
            <p>
              高知から、世界へ。一緒に、やりましょう。
            </p>

            <div className="pt-8 border-t border-white/20">
              <p className="font-serif text-white text-lg">武井 梨名</p>
              <p className="font-sans text-white/50 text-xs tracking-widest mt-1.5">
                Rina Takei &nbsp;|&nbsp; CEO, Chammi Inc.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
